import React, { useEffect, useRef, useState } from "react";
import "./ResetPass.css";
import { Container } from "react-bootstrap";
import Logo from "../../Common-Component/Reset_Flow/Logo/Logo";
import Heading from "../../Common-Component/Reset_Flow/Heading/Heading";
import CommonText from "../../Common-Component/Reset_Flow/Common_Text/CommonText";
import YellowFilledRoundBtn from "../../Common-Component/Common_Btn/YellowFilledRoundBtn/YellowFilledRoundBtn";
import OrangeFilledRoundBtn from "../../Common-Component/Common_Btn/OrangeFilledRoundBtn/OrangeFilledRoundBtn";
import Banner from "../../Common-Component/Reset_Flow/Banner/Banner";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { Button, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { sendMobileOtp, verifyOtp } from "../../../features/auth/authSlice";
export default function ResetPass() {
  const navigate = useNavigate();
  const [showOtpField, setShowOtpField] = useState(false);
  const [otpValues, setOtpValues] = useState(Array(5).fill(""));
  const inputRefs = useRef(new Array(5).fill(null));
  const [isEmailReadOnly, setIsEmailReadOnly] = useState(false);
  const [timer, setTimer] = useState(0);
  const [showOtpFields, setShowOtpFields] = useState(false);
 
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [email, setEmail] = useState("");
  const handleInputChange = (e, index) => {
    const { value } = e.target;

    if (!/^\d?$/.test(value)) return;

    const newOtpValues = [...otpValues];
    newOtpValues[index] = value;
    setOtpValues(newOtpValues);

    if (value && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (
      !/^[0-9]$/.test(e.key) &&
      e.key !== "Backspace" &&
      e.key !== "Tab" &&
      e.key !== "ArrowLeft" &&
      e.key !== "ArrowRight"
    ) {
      e.preventDefault();
    }

    if (e.key === "Backspace" && !otpValues[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const dispatch = useDispatch();
  const handleFirstSubmit = async (data) => {
    await clearErrors();
    if (!data || data.trim() === "") {
      setError("email_or_contact", {
        message: "Email or Mobile number is required",
      });
      return;
    }
    const res = await dispatch(sendMobileOtp({ email_or_contact: data }));
  
    if (res.meta?.requestStatus === "fulfilled") {
      setShowOtpField(true);
      setTimer(60);
    } else if (res.meta?.requestStatus === "rejected") {
      if (res.payload?.errors) {
        setError("email_or_contact", {
          type: "manual",
          message: res.payload?.errors,
        });
      }
    }
    // setShowOtpField(true);
  };

  const handleCloseinput = () => {
  
    setShowOtpField(false);
  };

  const handleFinalSubmit = () => {
    if (otpValues.some((val) => val === "")) {
      alert("Please fill all OTP fields");
      return;
    }
    navigate("/set-new-pass");
  };

 
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  
  const handleVerifyClick = async (email) => {
    if (!email || email.trim() === "") {
      setError("email", { message: "Email or Mobile number is required" });
      return;
    }
    const otpString = otpValues.join("");
    if (!otpString || otpString.trim() === "") {
      setError("otp", { message: "otp is required" });
      return;
    }

    await clearErrors();
    const data = { email_or_contact: email };
   
    data.otp = otpString;

    // setShimmerLoader(true);
    const res = await dispatch(verifyOtp(data));

  
    
    // const res = await CheckExist(data);
    if (res.meta?.requestStatus === "fulfilled") {
      if (otpValues.some((val) => val === "")) {
        alert("Please fill all OTP fields");
        return;
      }
      navigate("/set-new-pass", { state: { email_or_contact: email } });

      setOtp(["", "", "", ""]);
      //   emailOtpGet(data)
      setIsEmailReadOnly(true);
      setEmail(email);
      setShowOtpFields(true);
      setTimer(60);
    } else if(res.meta?.requestStatus === "rejected") {
      if (res.payload?.errors) {
        setError("otp", {
          type: "manual",
          message: res.payload?.errors,
        });
      }
      
    }
  };
  useEffect(() => {
    console.log(
      timer > 0,
      "showOtpFields && timer > 0 showOtpFields && timer > 0"
    );

    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);
  return (
    <section className="reset-pass login-page">
      <Container>
        <div className="reset-card card_holder">
          <Logo />
          <Heading
            headingText={
              <>
                RESET <br />
                YOUR PASSWORD
              </>
            }
          />
          <CommonText
            paraText={
              "You will receive an email from us requesting you to Reset your password."
            }
          />

          {/* <form className="reset-form"> */}
          <Form
            className="reset-form"
            onSubmit={handleSubmit(handleFirstSubmit)}
          >
            <div className="row field">
              <div className="col">
                <Form.Control
                  type="text"
                  name="email_or_contact"
                  placeholder="Enter Email or Mobile Number"
                  {...register("email_or_contact", {
                    required: "Email or Mobile is required",
                  })}
                  onChange={(e) => {
                    setIsEmailReadOnly(false);
                    // Optionally, update the form value if needed
                    // setValue("email", e.target.value);
                  }}
                  className={classNames("", {
                    "is-invalid": errors?.email_or_contact,
                    "is-valid": getValues("email_or_contact"),
                  })}
                  // readOnly={isEmailReadOnly}
                />
                {errors?.email_or_contact && (
                  <div className="mt-md-0 mt-sm-3 mt-3">
                    <sup className="text-danger  ">
                      {errors?.email_or_contact?.message}
                    </sup>
                  </div>
                )}
              </div>
            </div>

            {showOtpField && (
              <div className="field2">
                {timer > 0 && (
                  <>
                    <div className="content">
                      <div className="info">
                        OTP has been Sent to
                        <br /> the Email / Mobile Number
                      </div>

                      <div className="otp-field-holder">
                        {[...Array(5)].map((value, index) => (
                          <input
                            key={index}
                            className="otp_input"
                            type="text"
                            maxLength={1}
                            value={otpValues[index]}
                            onChange={(e) => handleInputChange(e, index)}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            ref={(el) => (inputRefs.current[index] = el)}
                          />
                          // <Form.Control
                          //   key={index}
                          //   type="text"
                          //   className="otp-field"
                          //   maxLength="1"
                          //   value={value}
                          //   id={`otp-${index}`}
                          //   onChange={(e) => handleInputChange(e, index)}
                          //   onKeyDown={(e) => handleKeyDown(e, index)}
                          // />
                        ))}
                      </div>
                    </div>
                  </>
                )}

                {timer > 0 ? (
                  <p>Time remaining: {timer} seconds</p>
                ) : (
                  <>
                    <p className="text-danger">
                      OTP expired.{" "}
                      <button
                        type="button"
                        className="resend-otp-btn-holder"
                        onClick={() =>
                          handleFirstSubmit(getValues("email_or_contact"))
                        }
                      >
                        Resend Otp
                      </button>
                    </p>
                  </>
                  // <div className="verify-text-holder" onClick={() => handleVerifyClick(getValues("email"))}>
                  //   <p className="text-danger">OTP expired. Please request a new OTP.</p>
                  // </div>
                )}
                {errors?.otp && timer > 0 && (
                  <div className="mt-md-0 mt-sm-3 mt-3">
                    <sup className="text-danger">{errors?.otp?.message}</sup>
                  </div>
                )}
              </div>
            )}

            <div className="buttons d-flex">
              <YellowFilledRoundBtn
                btnText={"Cancel"}
                onClick={handleCloseinput}
              />
              {!showOtpField ? (
                <OrangeFilledRoundBtn
                  btnText={"Submit"}
                  type={"submit"}
                  onClick={() =>
                    handleFirstSubmit(getValues("email_or_contact"))
                  }
                  // onClick={handleFirstSubmit}
                />
              ) : (
                <OrangeFilledRoundBtn
                  btnText={"Submit"}
                  type={"button"}
                  onClick={() =>
                    handleVerifyClick(getValues("email_or_contact"))
                  }
                  // onClick={handleVerifyClick}
                />
              )}
            </div>
          </Form>
          {/* </form> */}

          <div className="home-link text-center">
            <Link to={"/login"}>
              Back
              <span>
                <i class="fa-solid fa-angle-right arrow">‌</i>
              </span>
            </Link>
          </div>
        </div>
        <div className="img-holder">
          <Banner />
        </div>
      </Container>
    </section>
  );
}
